// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}

/* Container */
.profile-component-container {
  display: flex;
  height: auto;
  background-color: #f9f9f9;
}

/* Profile Sidebar */
.profile-sidebar {
  background-color: #f1f5f4;
  width: 250px;
  padding: 10px;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid #ddd;

  /* position: fixed; */
}

/* Profile Avatar */
.profile-avatar {
  width: 120px;
  height: 120px;
  background-color: #ddd;
  border-radius: 50%;
  margin-bottom: 15px;
}

/* Sidebar Title */
.profile-sidebar h2 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 10px;
}

/* Profile Details */
.profile-details p {
  margin: 5px 0;
  color: #555;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.profile-label {
  font-weight: 400;
}

.profile-value {
  color: #34a57e;
  padding: 10px 0;
  font-weight: 700;
}

/* Main Content */
.profile-main-content {
  display: flex;
  flex-direction: column;
  /* margin-left: 20px; To create space between the sidebar and main content */
  flex: 1 1;
  padding: 20px;
  gap: 20px;
}

/* Ensure DisplayDetailsOfUser doesn't override flexbox behavior */
.main-content {
  background: #fff;
  border-radius: 8px;
  padding: 0px 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  min-width: 80%;
  overflow: hidden;
  /* height: 150vh; */
}

@media screen and (max-width: 480px) {
  .main-content {
    overflow: scroll;
    /* width: %; */
    height: auto;
    min-width: 50%;
    width: 77%;
    /* height: 222%; */
    padding: 0px 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/ProfileComponent/ProfileComponent.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;;EAE5B,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,4EAA4E;EAC5E,SAAO;EACP,aAAa;EACb,SAAS;AACX;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":["/* General Reset */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: Arial, sans-serif;\n}\n\n/* Container */\n.profile-component-container {\n  display: flex;\n  height: auto;\n  background-color: #f9f9f9;\n}\n\n/* Profile Sidebar */\n.profile-sidebar {\n  background-color: #f1f5f4;\n  width: 250px;\n  padding: 10px;\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-right: 1px solid #ddd;\n\n  /* position: fixed; */\n}\n\n/* Profile Avatar */\n.profile-avatar {\n  width: 120px;\n  height: 120px;\n  background-color: #ddd;\n  border-radius: 50%;\n  margin-bottom: 15px;\n}\n\n/* Sidebar Title */\n.profile-sidebar h2 {\n  font-size: 1.5rem;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n/* Profile Details */\n.profile-details p {\n  margin: 5px 0;\n  color: #555;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.profile-label {\n  font-weight: 400;\n}\n\n.profile-value {\n  color: #34a57e;\n  padding: 10px 0;\n  font-weight: 700;\n}\n\n/* Main Content */\n.profile-main-content {\n  display: flex;\n  flex-direction: column;\n  /* margin-left: 20px; To create space between the sidebar and main content */\n  flex: 1;\n  padding: 20px;\n  gap: 20px;\n}\n\n/* Ensure DisplayDetailsOfUser doesn't override flexbox behavior */\n.main-content {\n  background: #fff;\n  border-radius: 8px;\n  padding: 0px 20px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  min-width: 80%;\n  overflow: hidden;\n  /* height: 150vh; */\n}\n\n@media screen and (max-width: 480px) {\n  .main-content {\n    overflow: scroll;\n    /* width: %; */\n    height: auto;\n    min-width: 50%;\n    width: 77%;\n    /* height: 222%; */\n    padding: 0px 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
